import { lazy } from "react";

const Complaint = lazy(() => import("@views/Complaint/Register"))
const Leave = lazy(() => import("@views/Complaint/Leave"))
const Movement = lazy(() => import("@views/Complaint/Movement"))

const ComplaintRoutes = [
    {
        path: 'complaint/register',
        element: <Complaint/>
    },
    {
        path: 'complaint/leave',
        element: <Leave/>
    },
    {
        path: 'movement',
        element: <Movement/>
    },
]
export default ComplaintRoutes
